import ReactDOM from 'react-dom';
import { usePortal } from './hooks';
export function Portal(props) {
    const portal = usePortal();
    if (!portal.element) {
        return null;
    }
    return ReactDOM.createPortal(props.children, portal.element);
}
//# sourceMappingURL=portal.js.map